import { useDmMessagePatient } from '../../../../hooks/useDmMessagesInbox';
import {
    patientViewStatus,
    useLastKnownNeighbours,
    useListPositionLabel
} from '../../shared/patientViewState';
import type { MessageListParams } from '../messageListParams';
import { useMessageApiFilters } from '../useMessageApiFilters';

// Mount one per patient (keyed by id): the remembered neighbours and position are that patient's alone.
export function useMessagePatientView(patientId: string, listParams: MessageListParams) {
    const { apiFilters, assigneesResolved } = useMessageApiFilters(listParams);
    const query = useDmMessagePatient(patientId, apiFilters, { enabled: assigneesResolved });
    const neighbours = useLastKnownNeighbours(query.data);
    const listPosition = query.data?.listPosition;
    const positionLabel = useListPositionLabel(listPosition);

    return {
        status: patientViewStatus(query.data !== undefined, query.isError, query.error),
        patient: query.data?.patient ?? null,
        ...neighbours,
        positionLabel,
        listTotal: listPosition?.total ?? null,
        retry: () => void query.refetch()
    };
}
